import styled from "styled-components";

export const Container = styled.nav`
  color: #ffffff;
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 400;
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  background: ${localStorage.getItem("@ecorban-app:theme")
    ? localStorage.getItem("@ecorban-app:theme")
    : "#2f4050"};
  z-index: 99999999;

  .menu-principal {
    display: flex;

    a {
      display: block;
      text-decoration: none;
      color: #ffffff;
      font-size: 1.2rem;
    }

    &__item {
      padding: 1.3rem;
      cursor: pointer;
      border-right: thin solid rgba(0, 0, 0, 0.2);
      border-bottom: 2px solid rgba(0, 0, 0, 0.2);
      transition: background-color 0.2s ease;
      position: relative;
      display: flex;
      align-items: center;

      .fa-angle-right {
        right: 0;
        font-size: 1.1rem;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.5rem;
      }

      i {
        margin-right: 0.9rem;
        font-size: 1.2rem;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
        color: rgba(255, 255, 255, 1);
        border-bottom: 2px solid rgb(26, 179, 148);
      }

      &.without_sub {
        padding: 0;

        a {
          padding: 1.3rem;
        }
      }

      &__sub {
        position: absolute;
        list-style: none;
        top: calc(100% + 2px);
        left: 0;
        display: none;

        &.active {
          display: block;
        }

        &__item {
          padding: 1.3rem;
          background-color: ${localStorage.getItem("@ecorban-app:theme")
            ? localStorage.getItem("@ecorban-app:theme")
            : "#2f4050"};
          border-bottom: thin solid rgba(0, 0, 0, 0.2);
          min-width: 20rem;
          position: relative;

          &.without_sub {
            padding: 0;

            a {
              padding: 1.3rem;
            }
          }

          &:hover {
            background-color: #263340;
          }

          &__sub {
            position: absolute;
            list-style: none;
            left: 100%;
            top: 0;
            border-left: thin solid #263340;
            display: none;

            &.active {
              display: block;
            }

            &__item {
              background-color: ${localStorage.getItem("@ecorban-app:theme")
                ? localStorage.getItem("@ecorban-app:theme")
                : "#2f4050"};
              border-bottom: thin solid rgba(0, 0, 0, 0.2);
              min-width: 20rem;
              position: relative;

              a {
                display: block;
                padding: 1.3rem;
                text-decoration: none;
                color: #ffffff;

                &:hover {
                  color: rgba(255, 255, 255, 1);
                }
              }

              &:hover {
                background-color: #263340;
              }
            }
          }

          &.active {
            .menu-principal__item__sub__item__sub {
              display: block;
            }
          }
        }
      }

      &.active {
        .menu-principal__item__sub {
          display: block;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/MenuHorizontal/styles.js